module.exports = __webpack_public_path__ + "static/media/team-2.857dd35c.jpg";